<template>
    <div class="cart-bg">
        <gallery :gallery.sync="gallery"></gallery>
        <div v-if="!getGalleryVisible">
            <div class="container">
                <div class="row mt-3 header-panel">
                    <div class="col-md-6 col-sm-12">
                        <h5 class="page-title">O seu carrinho</h5>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <h4 class="text-right">
                            total
                            <b>{{ parseDecimalPlaces(getTotalPrice) }} Eur</b>
                        </h4>
                    </div>
                    <div class="row d-none d-sm-block">
                        <ul clasS="shopping-nav">
                            <li>1. Galeria</li>
                            <li :class="{'active' : getCartListingVisible}">2. Carrinho</li>
                            <li :class="{'active' : getCheckoutFormVisible}">3. Os Seus Dados</li>
                            <li :class="{'active' : orderCompletedVisible}">4. Encomenda Concluída</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <cart-listing :gallery.sync="gallery"></cart-listing>
        <slot v-if="gallery">
            <cart-form-component v-if="!gallery.is_sale_in_place" :gallery.sync="gallery"></cart-form-component>
            <cart-form-component-sale v-if="gallery.is_sale_in_place" :gallery.sync="gallery"></cart-form-component-sale>
        </slot>
        <!-- completed -->
    </div>
</template>

<script>
import Gallery from "./Gallery.vue";
import CartListing from "./CartListing.vue";
import CartFormComponent from "./CartFormComponent.vue";
import CartFormComponentSale from "./CartFormComponentSale.vue";
import { mapGetters } from "vuex";

export default {
    name: "CartComponent",
    components: {
        Gallery,
        CartListing,
        CartFormComponent,
        CartFormComponentSale
    },
    data(){
        return {
            gallery: {}
        }
    },
    mounted() {
        this.getGallery();
    },
    methods: {
        async getGallery() {
            await axios.get("/gallery").then((response) => {
                this.gallery = response.data.data.gallery;
                this.$store.dispatch('setGallery', this.gallery);
            });
        },
        parseDecimalPlaces(value) {
            return Number(
                Math.round(parseFloat(value + "e" + 2)) + "e-" + 2
            ).toFixed(2);
        },
    },
    computed: {
        ...mapGetters(["getCartListingVisible","getCheckoutFormVisible", "orderCompletedVisible", "getGalleryVisible","getTotalPrice","imageSizes"]),
    },
};
</script>
